import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { logout } from '../../actions/authActions';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false
        };
    }

    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
    }

    render() {
        return (
            <header className="app-header navbar">
                <button className="navbar-toggler mobile-sidebar-toggler d-lg-none" onClick={this.mobileSidebarToggle} type="button">&#9776;</button>
                <a className="navbar-brand" href="#0"><p className="sr-only">Syngeos</p></a>
                <ul className="nav navbar-nav d-md-down-none mr-auto">
                    <li className="nav-item px-3">
                        <Link className="nav-link" to="/admin/users">
                            <FormattedMessage id="navigation.users"/>
                        </Link>
                    </li>
                    <li className="nav-item px-3">
                        <Link className="nav-link" to="/admin/users/admins">
                            <FormattedMessage id="navigation.admins"/>
                        </Link>
                    </li>
                    <li className="nav-item px-3">
                        <Link className="nav-link" to="/admin/devices">
                            <FormattedMessage id="navigation.devices"/>
                        </Link>
                    </li>
                    <li className="nav-item px-3">
                        <Link className="nav-link" to="/admin/areas">
                            <FormattedMessage id="navigation.areas"/>
                        </Link>
                    </li>
                </ul>
                <ul className="nav navbar-nav ml-auto">
                    <li className="nav-item">
                        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                            <button onClick={this.toggle} className="nav-link dropdown-toggle" data-toggle="dropdown" type="button" aria-haspopup="true" aria-expanded={this.state.dropdownOpen}>
                                <span className="d-md-down-none">{this.props.username ? this.props.username : this.props.userEmail}</span>
                            </button>
                            <DropdownMenu className="dropdown-menu-right">
                                <DropdownItem header className="text-center"><strong></strong></DropdownItem>
                                <DropdownItem onClick={this.props.logout}><i className="fa fa-lock"></i>
                                <FormattedMessage id="navigation.logout"/>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </li>
                <li className="nav-item d-md-down-none">
                </li>
            </ul>
        </header>
    )
}
}

export default connect(
    (state) => ({
        userEmail: state.user.info.data.email,
        username: state.user.info.data.name,
    }),
    ({
        logout
    }),
)(injectIntl(Header));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js